export default [
    {
        id: 'edge-1-2',
        source: 'node-1',
        target: 'node-2',
    },
    {
        id: 'edge-form-1',
        source: 'node-form',
        target: 'node-1',
    },

    {
        id: 'edge-1-3',
        source: 'node-1',
        target: 'node-3',
        animated: true,
    },
    {
        id: 'edge-2-6',
        source: 'node-2',
        target: 'node-6',
    },
    {
        id: 'edge-4-6',
        source: 'node-4',
        target: 'node-6',
    },
    {
        id: 'edge-3-5',
        source: 'node-3',
        target: 'node-5',

    },
    {
        id: 'edge-3-4',
        source: 'node-3',
        target: 'node-4',

    },
    {
        id: 'edge-5-7',
        source: 'node-5',
        target: 'node-7',

    },
    {
        id: 'edge-6-7',
        source: 'node-6',
        target: 'node-7',
    },
];